export function TextReducer({text, maxsize}) 
{
    if ( text?.length <= maxsize )
     return ( <span > { text }  </span> )
    else{
        const reducer = text?.slice(0, maxsize) + '...';
        return ( <span > { reducer }  </span> )
    }
}